import { createSlice } from "@reduxjs/toolkit";

const forgerockUserInfoSlice = createSlice({
    name: "forgerockUserInfoReducer",
    initialState: {},
    reducers: {
        updateForgerockUserInfo: (state, action) => {
            return {
                ...state,
                ...action.payload
            }
        },
        resetForgerockUserInfo: () => {
            return {}
        }
    }
});

export const { updateForgerockUserInfo, resetForgerockUserInfo } = forgerockUserInfoSlice.actions;
export default forgerockUserInfoSlice.reducer;